import axios from "axios";
import config from '../../config/config'
const _axios = axios.create({ 
    baseURL: config.baseUrl,
    withCredentials: true });

export default _axios;
